module.exports = __webpack_public_path__ + "img/Frame-25.392cbbaa.svg";